
// Minimal layout for the redesigned client email suite (appointment lifecycle
// emails). Unlike `email.vue` (used by summaries/OTP/etc.), it adds NO visible
// chrome — each page renders a self-contained, 600px table-based body via the
// <ClientSuiteFrame> component. This layout only owns the <head>: the
// color-scheme lock, the Work Sans web font, and the shared responsive @media
// block (the only CSS that can't be inlined, preserved by juice at render time).
export default {
    name: 'ClientSuiteEmail',
    head () {
        return {
            title: "Doctor's Choice",
            meta: [
                { hid: 'color-scheme', name: 'color-scheme', content: 'light' },
                { hid: 'supported-color-schemes', name: 'supported-color-schemes', content: 'light' },
            ],
            link: [
                { hid: 'work-sans', rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600;700&display=swap' },
            ],
            style: [
                {
                    hid: 'client-suite-media',
                    type: 'text/css',
                    cssText: '@media(max-width:480px){.body-pad{padding:26px 22px 30px !important;}.head-pad{padding:16px 22px !important;}.head-help{display:none !important;}.btn-tbl{width:100% !important;}.btn-a{display:block !important;text-align:center !important;}}',
                },
            ],
            // vue-meta escapes cssText by default, which would mangle the media
            // query braces; allow the raw <style> through.
            __dangerouslyDisableSanitizers: ['style'],
        }
    },
}
